// memoryCache private olarak tanımlanır, dışarı açılmaz
const memoryCache: Record<string, any[]> = {};

const set = (key: string, value: any[]) => {
    if (!key) return;
    memoryCache[key] = value;
};

const get = (key: string): any[] | undefined => {
    return memoryCache[key];
};

const clear = (key: string) => {
    delete memoryCache[key];
};

const clearAll = () => {
    Object.keys(memoryCache).forEach((key) => delete memoryCache[key]);
};

const keys = (): string[] => {
    return Object.keys(memoryCache);
};

const getAll = (): Readonly<Record<string, any[]>> => {
    return { ...memoryCache };
};

export const enumMemoryCache = {
    set,
    get,
    clear,
    clearAll,
    keys,
    getAll,
};
